type Guard = (proceed: () => void) => boolean;

let activeGuard: Guard | null = null;

export function setNavGuard(guard: Guard | null) {
  activeGuard = guard;
}

export function guardedNavigate(proceed: () => void) {
  if (activeGuard && !activeGuard(proceed)) return;
  proceed();
}
